module.exports = __webpack_public_path__ + "img/news-06_2x.0eb0bb49.png";